/** Angular Imports. */
import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Dates } from 'app/core/utils/dates';

/** Custom Services. */
import { ProductsService } from 'app/products/products.service';
import { SettingsService } from 'app/settings/settings.service';
import { STANDALONE_SHARED_IMPORTS } from 'app/standalone-shared.module';

/**
 * Create Dividend component.
 */
@Component({
  selector: 'LOSx-create-dividend',
  templateUrl: './create-dividend.component.html',
  styleUrls: ['./create-dividend.component.scss'],
  imports: [
    ...STANDALONE_SHARED_IMPORTS
  ]
})
export class CreateDividendComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);
  private route = inject(ActivatedRoute);
  private dateUtils = inject(Dates);
  private productService = inject(ProductsService);
  private router = inject(Router);
  private settingsService = inject(SettingsService);

  /** Create Dividend Form. */
  createDividendForm: UntypedFormGroup;
  /** Share Product data. */
  shareProductData: any;
  /** Minimum Date allowed. */
  minDate = new Date(2000, 0, 1);
  /** Maximum Date allowed. */
  maxDate = new Date();

  /**
   * Get Share Product data from `Resolver`.
   * @param {FormBuilder} formBuilder Form Builder.
   * @param {ActivatedRoute} route Activated Route.
   * @param {Dates} dateUtils Date Utils to format date.
   * @param {ProductsService} productsService Products Service.
   * @param {Router} router Router.
   * @param {SettingsService} settingsService Settings Service.
   */
  constructor() {
    this.route.data.subscribe((data: { shareProduct: any }) => {
      this.shareProductData = data.shareProduct;
    });
  }

  ngOnInit() {
    this.maxDate = this.settingsService.businessDate;
    this.setDividendForm();
  }

  /**
   * Sets Create Dividend from.
   */
  setDividendForm() {
    this.createDividendForm = this.formBuilder.group({
      dividendPeriodStartDate: [
        '',
        Validators.required
      ],
      dividendPeriodEndDate: [
        '',
        Validators.required
      ],
      dividendAmount: [
        '',
        Validators.required
      ]
    });
  }

  /**
   * Submits Create Dividend form.
   */
  submit() {
    const createDividendFormData = this.createDividendForm.value;
    const locale = this.settingsService.language.code;
    const dateFormat = this.settingsService.dateFormat;
    const prevStartDate: Date = this.createDividendForm.value.dividendPeriodStartDate;
    const prevEndDate: Date = this.createDividendForm.value.dividendPeriodEndDate;
    if (createDividendFormData.dividendPeriodStartDate instanceof Date) {
      createDividendFormData.dividendPeriodStartDate = this.dateUtils.formatDate(prevStartDate, dateFormat);
    }
    if (createDividendFormData.dividendPeriodEndDate instanceof Date) {
      createDividendFormData.dividendPeriodEndDate = this.dateUtils.formatDate(prevEndDate, dateFormat);
    }
    const data = {
      ...createDividendFormData,
      dateFormat,
      locale
    };
    this.productService.createDividend(this.shareProductData.id, data).subscribe((response: any) => {
      this.router.navigate(['../'], { relativeTo: this.route });
    });
  }
}
